import { HEALTH_DEVELOPMENT_CHART_COLORS } from '../../healthChartColors';

export const ALERT_LEVEL_COLORS: Record<string, string> = {
    high: HEALTH_DEVELOPMENT_CHART_COLORS.red,
    increasing: HEALTH_DEVELOPMENT_CHART_COLORS.orange,
    stable: HEALTH_DEVELOPMENT_CHART_COLORS.green,
};

export const OVERVIEW_SCORE_LEGEND = [
    {
        key: 'score0',
        labelKey: 'dashboard.laksvelScore0',
        color: HEALTH_DEVELOPMENT_CHART_COLORS.green,
    },
    {
        key: 'score1',
        labelKey: 'dashboard.laksvelScore1',
        color: HEALTH_DEVELOPMENT_CHART_COLORS.yellow,
    },
    {
        key: 'score2',
        labelKey: 'dashboard.laksvelScore2',
        color: HEALTH_DEVELOPMENT_CHART_COLORS.orange,
    },
    {
        key: 'score3',
        labelKey: 'dashboard.laksvelScore3',
        color: HEALTH_DEVELOPMENT_CHART_COLORS.red,
    },
] as const;
